import React from 'react';
import { AlertTriangle, Target, Users } from 'lucide-react';
export function DiagnosticoSection() {
  const problems = [{
    icon: <AlertTriangle className="w-8 h-8 text-gold" data-id="element-78" />,
    title: 'Limpieza residencial por proyecto no es un negocio, es un empleo.',
    description: 'El negocio real está en contratos semanales o quincenales con propietarios y empresas que pagan automáticamente cada mes.'
  }, {
    icon: <Target className="w-8 h-8 text-gold" data-id="element-79" />,
    title: 'No estás en el segmento correcto.',
    description: 'Limpiar por $80 atrae al cliente que mañana encuentra a alguien por $70 y te cambia sin pensarlo. El segmento de limpieza premium (propiedades de lujo, oficinas, Airbnb) busca confianza y consistencia. Ese segmento paga 3 veces más y no cambia de proveedor si estás haciendo bien tu trabajo.'
  }, {
    icon: <Users className="w-8 h-8 text-gold" data-id="element-80" />,
    title: 'No tienes sistema de referidos activo.',
    description: 'El mejor cliente de limpieza es el amigo del cliente actual. Sin un sistema automatizado de referidos, estás dejando dinero sobre la mesa todos los días.'
  }];
  return <section id="diagnostico" className="py-20 px-4 sm:px-6 lg:px-8 bg-carbon-light border-y border-carbon-lighter" data-id="element-81">
      <div className="max-w-6xl mx-auto" data-id="element-82">
        <div className="text-center mb-16" data-id="element-83">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-84">
            <span className="text-gold" data-id="element-85">EL DIAGNÓSTICO:</span> ¿Por qué no estás
            creciendo?
          </h2>
          <p className="text-gray-400 max-w-2xl mx-auto" data-id="element-86">
            Si trabajas 12 horas al día y los números no cuadran a fin de mes,
            el problema no es tu esfuerzo, es tu modelo de negocio.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-87">
          {problems.map((problem, index) => <div key={index} className="bg-carbon border border-carbon-lighter p-8 rounded-lg flex flex-col h-full" data-id="element-88">
              <div className="mb-6 bg-carbon-light w-16 h-16 rounded-full flex items-center justify-center border border-carbon-lighter" data-id="element-89">
                {problem.icon}
              </div>
              <h3 className="text-xl font-bold text-white mb-4 leading-snug" data-id="element-90">
                {problem.title}
              </h3>
              <p className="text-gray-400 leading-relaxed flex-grow" data-id="element-91">
                {problem.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}